export function isReactNative(): boolean {
  return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
}

/**
 * True when rendered inside our native React Native WebView host
 * (`ReactNativeWebView` bridge or the `isWebViewV2` global the native side injects).
 */
export function isWebView(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const win = window as unknown as {
    isWebViewV2?: boolean;
    ReactNativeWebView?: unknown;
  };

  return win.isWebViewV2 === true || Boolean(win.ReactNativeWebView);
}

/**
 * True when rendered inside a third-party in-app browser (Facebook, Instagram,
 * Line, WhatsApp, etc.) via query params or user-agent — distinct from our own
 * WebView host (see `isWebView`).
 *
 * Copied from identity-shared's `isInAppBrowser` rather than depending on that
 * (large) package for a single function.
 */
export function isInAppBrowser(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('webview') === 'true' || params.get('is_mobile_app') === 'true') {
      return true;
    }
  } catch {
    // ignore URL parsing errors
  }

  const userAgent = window.navigator.userAgent.toLowerCase();

  return (
    userAgent.includes('wv') || // Android WebView
    (userAgent.includes('safari') &&
      userAgent.includes('mobile') &&
      !userAgent.includes('chrome')) || // iOS WebView
    userAgent.includes('fbav') || // Facebook
    userAgent.includes('instagram') || // Instagram
    userAgent.includes('line') || // Line
    userAgent.includes('whatsapp') // WhatsApp
  );
}
